import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { formatDate } from "@/lib/api";

export function PodcastCard({ episode, dark = false }) {
  if (!episode) return null;
  return (
    <Link to={`/podcasts/${episode.slug}`} className="group block" data-testid={`podcast-episode-card-${episode.slug}`}>
      <div className="relative overflow-hidden bg-[#0A1B2E] mb-3 aspect-video">
        <img src={episode.thumbnail} alt={episode.title} loading="lazy" className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-[#C47A35]/90 flex items-center justify-center group-hover:scale-110 transition-transform" data-testid="podcast-play-button">
            <Play className="w-6 h-6 text-white fill-white" />
          </div>
        </div>
      </div>
      <span className={`text-[11px] font-bold uppercase tracking-[0.15em] ${dark ? "text-[#C47A35]" : "text-[#C47A35]"}`}>Подкаст</span>
      <h3 className={`mt-1 font-serif text-lg font-semibold leading-snug transition-colors ${dark ? "text-white group-hover:text-[#C47A35]" : "text-[#10243A] group-hover:text-[#C47A35]"}`}>
        {episode.title}
      </h3>
      <div className={`mt-1 text-xs ${dark ? "text-[#8FA2B3]" : "text-[#66717B]"}`}>
        {episode.guest && <span>{episode.guest} &middot; </span>}
        <span>{formatDate(episode.published_at)}</span>
      </div>
    </Link>
  );
}
